(function () {
  if (window.__jobOpeningLoaded) return;
  window.__jobOpeningLoaded = true;

  /* 关键词转模糊匹配正则:前后补通配实现包含匹配,输入中的 * 也按通配符处理,其余特殊字符转义 */
  function buildKeywordPattern(keyword) {
    var escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\\*/g, '.*');
    return new RegExp('^.*' + escaped + '.*$', 'i');
  }

  /* 页内筛选:不请求数据,按勾选条件与搜索关键字显隐卡片 */
  function filterJobs(root) {
    var cards = root.querySelectorAll('.job-opening__card');
    if (!cards.length) return;

    var cities = [];
    var fcs = [];
    root.querySelectorAll('.job-opening__filter-input').forEach(function (input) {
      if (!input.checked) return;
      if (input.dataset.filterType === 'city') {
        cities.push(input.value);
      } else if (input.dataset.filterType === 'fc') {
        fcs.push(input.value);
      }
    });

    var searchInput = root.querySelector('.job-opening__search-input');
    var keyword = searchInput ? searchInput.value.trim() : '';
    var pattern = keyword ? buildKeywordPattern(keyword) : null;

    var visibleCount = 0;
    cards.forEach(function (card) {
      /* cities 收集的是条目 c_name 与岗位 tag 匹配;fcs 收集的是 fun_name 与岗位 functional_classification 匹配 */
      var cityOk = cities.length === 0 || cities.indexOf(card.dataset.tag) !== -1;
      var fcOk = fcs.length === 0 || fcs.indexOf(card.dataset.fc) !== -1;
      var kwOk = !pattern || pattern.test(card.dataset.search || '');
      var show = cityOk && fcOk && kwOk;
      card.hidden = !show;
      if (show) visibleCount += 1;
    });

    var empty = root.querySelector('.job-opening__empty');
    if (empty) empty.hidden = visibleCount !== 0;
  }

  /* 展开/收起:按钮控制其前方最近的内容块 */
  function toggleExpand(button) {
    var content = button.previousElementSibling;
    while (content && !content.classList.contains('job-opening__content')) {
      content = content.previousElementSibling;
    }
    if (!content) return;
    var isOpen = button.classList.toggle('is-open');
    content.classList.toggle('is-open', isOpen);
    var text = button.querySelector('.job-opening__expand-text');
    if (text) text.textContent = isOpen ? button.dataset.collapseLabel : button.dataset.expandLabel;
  }

  /* 全部事件委托到 document,section 局部刷新后新 DOM 依然生效 */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.job-opening__filter-input');
    if (input) filterJobs(input.closest('.job-opening'));
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest('.job-opening__search-input')) return;
    filterJobs(event.target.closest('.job-opening'));
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.classList.contains('job-opening__search')) return;
    event.preventDefault();
    filterJobs(event.target.closest('.job-opening'));
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('.job-opening__clear');
    if (clear) {
      var clearRoot = clear.closest('.job-opening');
      clearRoot.querySelectorAll('.job-opening__filter-input').forEach(function (input) {
        input.checked = false;
      });
      var clearSearch = clearRoot.querySelector('.job-opening__search-input');
      if (clearSearch) clearSearch.value = '';
      filterJobs(clearRoot);
      return;
    }
    /* 搜索按钮点击兑底:个别环境 submit 事件未触发时仍能执行筛选 */
    var submitBtn = event.target.closest('.job-opening__search-submit');
    if (submitBtn) {
      filterJobs(submitBtn.closest('.job-opening'));
      return;
    }
    var expand = event.target.closest('.job-opening__expand');
    if (expand) toggleExpand(expand);
  });
})();
